// Havuz formu → API gövdesi. Dinamik havuzda kural süzgeçleri VE ile daralır (kademe dahil — spec 2026-10-27 §7.5).
export function buildPoolPayload(formData) {
  const dynamic = formData.poolType === 'dynamic';
  return {
    name: formData.name,
    poolType: formData.poolType,
    ruleCellKeys: dynamic ? (formData.ruleCellKeys || []) : undefined,
    ruleFilterJson: dynamic ? {
      departmentIds: formData.ruleDepartmentIds || [],
      minSeniorityYears: formData.ruleMinSeniorityYears !== '' && formData.ruleMinSeniorityYears != null
        ? Number(formData.ruleMinSeniorityYears) : undefined,
      locationIds: formData.ruleLocationIds || [],
      gradeIds: formData.ruleGradeIds || [],
    } : undefined,
  };
}
